import API from '@axios'
import { stringify } from 'query-string'
import { apiHelper } from '../helpers/apiHelper'

export default {
    async deleteById(id) {
        return API.delete(`/api/crm/contract/template/${id}`)
    },
    getAll(query = { size: 25 }) {
        return API.get(`/api/crm/contract/getall?${stringify(query)}`)
    },
    getActiveCommissionModels(companyIds) {
        const req = {
            companyIds,
        }
        return API.put('/api/crm/contract/get-commission-models', req)
    },
    async getFormFields(file) {
        const formData = new FormData()
        formData.append('name', 'form')
        formData.append('file', file)
        const contractTemplateReq = {
        formFieldList: [],
        }
        formData.append('contractTemplateReq',
            new Blob([JSON.stringify(contractTemplateReq)], {
            type: 'application/json',
        }))
        return API.put('/api/crm/contract/wizard/upload', formData)
    },
    getEntities() {
        return API.get('/api/crm/tree/fields/company')
    },
    async getTemplateById(id) {
        return API.get(`/api/crm/contract/template/${id}`)
    },
    async getSubsidiaries(companyUuid) {
        return API.get(`/api/crm/contract/get-subsidiaries/${companyUuid}`)
    },
    async b64toBlob(base64, contentType = 'application/octet-stream') {
        let blobbie = null
        await fetch(`data:${contentType};base64,${base64}`).then(res => { blobbie = res.blob() })
        return blobbie
    },
    viewBlobFileInNewTab(file) {
        const fileURL = window.URL.createObjectURL(file)
        const tab = window.open()
        tab.location.href = fileURL
    },
    async viewRawPdfFileInNewTab(base64) {
        const pdfFile = await this.b64toBlob(base64, 'application/pdf')
        this.viewBlobFileInNewTab(pdfFile)
    },
    async viewPadesPdfFileInNewTab(base64) {
        const pdfFile = await this.b64toBlob(base64, 'application/pdf')
        this.viewBlobFileInNewTab(pdfFile)
    },
    async generate(req) {
        return API.put('/api/crm/contract/generate', req)
    },
    async linkDocument(docLinkReqRes) {
        console.log('linkDocument docLinkReqRes', docLinkReqRes)
        return API.post('/api/crm/contract/link-document', docLinkReqRes)
    },
    async b64toBlobPROTO(base64, contentType) {
        let blobbie = null
        await fetch(`data:${contentType};base64,${base64}`).then(res => { blobbie = res.blob() })
        return blobbie
    },
    async showPdfInNewTab(base64Data) {
        const pdfFile = await this.b64toBlobPROTO(base64Data, 'application/pdf')
        this.viewBlobFileInNewTab(pdfFile)
    },
    async mockGenerate() {
        // const req = JSON.parse('{"companyId":"96b642f5-5e40-49dc-bec7-fb20b943dc8b","templateId":36,"generateAllRelation":true,"documentName":"formidleravtale-2025-09-05","overrideInputs":{"Sted":"k","Dato":"jjj","Sted_2":"ll","Dato_2":"lll"},"parentOnly":false,"subsidiaryList":["a53d97b4-5906-49f6-b270-276d7fd5b562","dceae800-cd99-4cdd-b2e8-99dbd9d7e50c","17da568b-b2af-418c-9002-c2a7199d8871"]}')
        // parent only
        const req = JSON.parse('{"companyId":"96b642f5-5e40-49dc-bec7-fb20b943dc8b","templateId":36,"generateAllRelation":true,"documentName":"formidleravtale-2025-09-09-maine","overrideInputs":{"Sted":"x","Dato":"a","Sted_2":"s","Dato_2":"s"},"parentOnly":true,"subsidiaryList":["a53d97b4-5906-49f6-b270-276d7fd5b562","dceae800-cd99-4cdd-b2e8-99dbd9d7e50c","17da568b-b2af-418c-9002-c2a7199d8871","dbcd5bd7-574b-4b99-82df-598014a2de69","fe67565d-eced-4982-bef9-d39fdc2d4f82","1c4a7cb2-a87e-49cf-a607-a788cacbdac0"]}')

        const resres = await this.generate(req)
        const docLinkReqRes = resres.data
        console.log('docLinkReqRes', docLinkReqRes)
        await this.linkDocument(docLinkReqRes)
    },

}
